import React, { useState, useEffect } from "react";
import { HomePage } from "./home.js";
import { replaceAllStoriesInCollection } from "@quintype/components";
import { object, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { getDomainSlugFromSections } from "../../../isomorphic/components/utils/utils";

let HomePagePreview = (props) => {
  const [started, setStarted] = useState(false);
  const [data, setData] = useState(props.data);

  const collectStoryData = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const previewParams = urlParams.get("previewParams");

    global.addEventListener("message", (event) => {
      if (event.data.story) {
        setStarted(true);
        const storyData = Object.assign({}, data, {
          collection: props.data.collection
            ? replaceAllStoriesInCollection(props.data.collection, event.data.story)
            : null,
        });
        setData(storyData);
        const currentFirstSection = get(event.data.story, ["sections", "0", "name"], "");
        const currentDomainSlug = getDomainSlugFromSections(props.sections, currentFirstSection);
        if (currentDomainSlug && previewParams === null) {
          window.location = "?previewParams=" + currentDomainSlug;
        }
      }
    });
  };

  useEffect(() => {
    collectStoryData();
  }, []);

  if (!started) return <div />;
  return <HomePage data={data} />;
};

HomePagePreview.propTypes = {
  data: object,
  sections: array,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
});
HomePagePreview = connect(mapStateToProps)(HomePagePreview);
export { HomePagePreview };
